<template>
  <b-link ref="hint" @click="openHintEditorDialog" :class="(helpMessage || editorMode  || isHintInputMessage) ? 'pl-1 fa-sm' : 'd-none'">
    <font-awesome-icon class="text-primary " :icon="['fas', 'info-circle']"/>
  </b-link>
</template>

<script>
import ValidatedField from "@/validation/ValidatedField";
import {parseIconName} from "@/FontAwesomeSetup";
import DialogManager from "@/utils/DialogManager";
import FormFieldConfig from "@/server/com/silkplm/engine/forms/schema/definition/FormFieldConfig";

export default {
  name: "HintEditor",

  async mounted() {
  },

  methods: {

    async openHintEditorDialog() {
      EventBus.$emit(Events.cancelHidingGridCellEditor, true);

      let res = await DialogManager.hintEditor(this.fieldConfig.fieldLabel, this.helpMessage, this.editorMode,
          this.validatedField.getGenerateFormClassPath?.(this.validatedField), this.fieldConfig.fieldLabel, this.isHintInputMessage);
      if(res){
        const regex = /^<[^>]*><\/[^<]*>$/;
        this.isHintInputMessage = !regex.test(res.hintMessage);
      }
    },
  },

  model: {
    prop: 'inputValue',
    event: 'model-change',
  },

  props: {
    helpMessage: {type: String, default: ""},
    editorMode: {type: Boolean, default: false},
    helpTitle: {type: String, default: ""},
    validatedField: {type: ValidatedField, default: null},
    fieldConfig: {type: FormFieldConfig, default: null},
  },

  watch: {
    'isHintInputMessage': function (val) {
      this.isHintInputMessage = val;
    }
  },

  data: () => ({
    isHintInputMessage: false,
  })
}
</script>
